import React, { useEffect, useContext, useRef, useState } from 'react';
import { Row, Col } from 'reactstrap';
import AppContext from '@contexts/AppContext';
import MultiSelect from 'react-multi-select-component';
import PortfolioService from '@services/PortfolioService';
import GridService from '@services/GridService';
import LawFirmAutoSuggest from '@components/LawFirmAutoSuggest/LawFirmAutoSuggest';
import './Styles.css';

const FilteringFields = (props) => {
  let dateFilter = useRef();
  let statusFilter = useRef();
  let applicationNoFilter = useRef();
  let lawFirmFilter = useRef();

  const clearFilters = () => {
    setDateValue('This month');
    dateFilter.current.value = 'This month';
    appContext.financialSummaryReportFilters = {};
    setDaterange(false);
    setFromDate(null);
    setToDate(null);
    setStatusValue([]);
    setPortfolio([]);
    setSelectedLawFirm({});
    props.getAll();
  };
  const [statusValue, setStatusValue] = useState([]);
  const [portfolio, setPortfolio] = useState([]);
  const [applicationNo, setApplicationNo] = useState();

  const [portfolioOptions, setPortfolioOptions] = useState([]);
  const [dateRange, setDaterange] = useState(false);
  const [dateValue, setDateValue] = useState('This month');
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [appStatusOptions, setAppStatusOptions] = useState([]);
  const [selectedLawFirm, setSelectedLawFirm] = useState({});
  const appContext = useContext(AppContext);
  const financialSummaryReportFilters = appContext.financialSummaryReportFilters;

  function changeFunc() {
    const dateFilter = document.getElementById('dateFilter');
    const selectedDate = dateFilter.options[dateFilter.selectedIndex].value;
    if (selectedDate === 'Custom') {
      setDaterange(true);
      setDateValue(null);
    } else {
      setDaterange(false);
      setDateValue(selectedDate);
      setFromDate(null);
      setToDate(null);
    }
  }
  function changeFromDate() {
    const fromDate = document.getElementById('fromDate');
    const selectedFromDate = fromDate.value;
    setFromDate(selectedFromDate);
  }
  function changeToDate() {
    const toDate = document.getElementById('toDate');
    const selectedToDate = toDate.value;
    if (fromDate < selectedToDate) {
      setToDate(selectedToDate);
    } else {
      if (fromDate != null) {
      } else {
        alert('Select from date first');
      }
    }
  }
  function selectDateRange() {
    if (dateValue != null) {
      return dateValue;
    } else {
      if (fromDate != null && toDate != null) {
        let dateRange = {
          fromDate: new Date(fromDate).toISOString(),
          toDate: new Date(toDate).toISOString(),
        };
        return dateRange;
      } else {
        return '';
      }
    }
  }

  useEffect(() => {
    const isFiltersEmpty = Object.keys(financialSummaryReportFilters).length == 0;
    //Get application status options
    GridService.read('/Application/applicationstatuses').then((resp) => {
      if (!resp.data) return;
      if (resp.data.length > 0) {
        let tempStatusOptions = [];
        resp.data.map((item) => {
          tempStatusOptions.push({
            label: item,
            value: item,
          });
          setAppStatusOptions(tempStatusOptions);
        });
        if (
          props.defaultApplicationStatus &&
          props.defaultApplicationStatus !== '' &&
          props.defaultApplicationStatus.length > 0
        ) {
          setStatusValue([]);
          props.defaultApplicationStatus.map((stat) => {
            let newItem = {
              label: stat,
              value: stat,
            };
            setStatusValue((statusValue) => [...statusValue, newItem]);
          });
        }
      }
    });

    //Get portfolio list
    PortfolioService.search({}, '', '', 1, null, 50).then((response) => {
      let portfolioList = [];
      if (!response.data) return;
      if (response.data.data.length > 0) {
        response.data.data.map((item) => {
          portfolioList.push({
            label: item.portfolioName,
            value: item.publicId,
          });
        });
        if (!isFiltersEmpty) {
          if (financialSummaryReportFilters.portfolioName) {
            if (portfolioList.length > 0) {
              let tempportfolioName = [];
              financialSummaryReportFilters.portfolioName.map((item) => {
                const portfolio = portfolioList.find((portfolio) => portfolio.value === item);
                tempportfolioName.push({
                  label: portfolio.label,
                  value: item,
                });
              });
              setPortfolio(tempportfolioName);
            }
          }
        }
      }
      setPortfolioOptions(portfolioList);
    });

    //Retaining data by checking with appcontext
    if (!isFiltersEmpty) {
      if (financialSummaryReportFilters.dateRange) {
        if (typeof financialSummaryReportFilters.dateRange == 'string') {
          dateFilter.current.value = financialSummaryReportFilters.dateRange;
          setDateValue(financialSummaryReportFilters.dateRange);
          setDaterange(false);
          setFromDate(null);
          setToDate(null);
        } else {
          dateFilter.current.value = 'Custom';
          setDaterange(true);
          setDateValue(null);
          setFromDate(financialSummaryReportFilters.dateRange.fromDate.split('T')[0]);
          setToDate(financialSummaryReportFilters.dateRange.toDate.split('T')[0]);
        }
      }
      if (financialSummaryReportFilters.applicationStatus) {
        let tempAppStatus = [];
        financialSummaryReportFilters.applicationStatus.map((item) => {
          tempAppStatus.push({
            label: item,
            value: item,
          });
        });
        setStatusValue(tempAppStatus);
      }

      if (financialSummaryReportFilters.portfolioName) {
        let tempportfolioName = [];
        financialSummaryReportFilters.portfolioName.map((item) => {
          tempportfolioName.push({
            label: item,
            value: item,
          });
        });
        setPortfolio(tempportfolioName);
      }

      if (financialSummaryReportFilters.lawFirm) {
        setSelectedLawFirm(financialSummaryReportFilters.lawFirm)
      }

      applicationNoFilter.current.value = financialSummaryReportFilters.applicationNo
        ? financialSummaryReportFilters.applicationNo
        : '';
    }
  }, []);

  const search = () => {
    const tempStatusValue = [];
    const tempPortfolio = [];

    statusValue.map((status) => {
      tempStatusValue.push(status.value);
    });

    portfolio.map((port) => {
      tempPortfolio.push(port.value);
    });

    let filters = {
      dateRange: selectDateRange(),
      applicationStatus: tempStatusValue.length > 0 ? tempStatusValue : null,
      portfolioName: tempPortfolio.length > 0 ? tempPortfolio : null,
      applicationNo: applicationNoFilter.current.value,
      lawFirm: selectedLawFirm,
    };

    if (filters.dateRange === '') delete filters.dateRange;

    props.searchWithFilters(filters);
  };
  return (
    <>
      <Col md="3" className="float-left fin-summary-filtering-section">
        <Row className="mt-5">
          <Col md="6">
            <h2>Filters</h2>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col md="12">
            <label htmlFor="dateRange">Advance Date Range</label>
          </Col>
          <Col md="12">
            <select id="dateFilter" onChange={changeFunc} className="form-control" ref={dateFilter}>
              <option value="This month">This month</option>
              <option value="Today">Today</option>
              <option value="Yesterday">Yesterday</option>
              <option value="This week">This week</option>
              <option value="Last week">Last week</option>
              <option value="Last month">Last month</option>
              <option value="YTD">YTD</option>
              <option value="Custom">Custom</option>
            </select>
          </Col>
        </Row>
        {dateRange == true && (
          <>
            <Row className="mt-5">
              <Col md="12">
                <label htmlFor="dateRange">From</label>
              </Col>
              <Col md="12">
                <input
                  onChange={changeFromDate}
                  type="date"
                  id="fromDate"
                  className="form-control"
                  required="required"
                  defaultValue={fromDate}
                />
              </Col>
            </Row>
            <Row className="mt-5">
              <Col md="12">
                <label htmlFor="dateRange">To</label>
              </Col>
              <Col md="12">
                <input
                  onChange={changeToDate}
                  type="date"
                  id="toDate"
                  className="form-control"
                  required="required"
                  defaultValue={toDate}
                />
              </Col>
            </Row>
          </>
        )}

        <Row className="mt-5">
          <Col md="12">
             <label htmlFor="status">Advance #</label>
          </Col>
          <Col md="12">
            <input
              type="search"
              name="status"
              ref={applicationNoFilter}
              className="form-control"
            ></input>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col md="12">
            <label htmlFor="status">Portfolio</label>
          </Col>
          <Col md="12">
            <div>
              <MultiSelect
                value={portfolio}
                onChange={setPortfolio}
                labelledBy={'Portfolio'}
                options={portfolioOptions}
              />
            </div>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col md="12">
            <label htmlFor="status">Advance Status</label>
          </Col>
          <Col md="12">
            <div ref={statusFilter}>
              <MultiSelect
                value={statusValue}
                onChange={setStatusValue}
                labelledBy={'Application Status'}
                options={appStatusOptions}
              />
            </div>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col md="12">
            <label htmlFor="lawFirm">Law Firm</label>
          </Col>
          <Col md="12">
            <LawFirmAutoSuggest
              ref={lawFirmFilter}
              selectedLawFirm={(value) => { setSelectedLawFirm(value) }}
              selectedLawFirmName={() => { }}
              defaultLawFirm={selectedLawFirm}
            />
          </Col>
        </Row>

        <Row className="mt-5 mb-5">
          <Col md="6" className="pr-0">
            <span className="a-link">
              <a className="btn clear-filter-button" onClick={clearFilters}>
                Clear filters
              </a>
            </span>
          </Col>
          <Col md="6">
            <span className="a-link float-right">
              <a className="btn btn-primary search-btn" onClick={search}>
                <i class="fas fa-search"></i>
                Search
              </a>
            </span>
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default FilteringFields;
